import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Badge } from '../ui/badge';
import { formatDate } from '../../lib/utils';

const STATUS_BADGE = {
  DRAFT: 'bg-slate-100 text-slate-700',
  SUBMITTED: 'bg-amber-100 text-amber-800',
  SENT_BACK: 'bg-orange-100 text-orange-800',
  APPROVED: 'bg-emerald-100 text-emerald-800',
};

export function ReviewsList({ reviews, loading, onSelect, showEmployee = true }) {
  if (loading) {
    return <div className="py-10 text-center text-sm text-muted-foreground" data-testid="reviews-list-loading">Loading…</div>;
  }
  if (!reviews.length) {
    return <div className="py-10 text-center text-sm text-muted-foreground" data-testid="reviews-list-empty">No reviews found.</div>;
  }
  return (
    <Table data-testid="reviews-table">
      <TableHeader>
        <TableRow>
          {showEmployee && <TableHead>Employee</TableHead>}
          <TableHead>Review Date</TableHead>
          <TableHead>Score</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Next Review</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {reviews.map((r) => (
          <TableRow
            key={r.id}
            className="cursor-pointer hover:bg-muted/50"
            onClick={() => onSelect(r.id)}
            data-testid={`review-row-${r.id}`}
          >
            {showEmployee && <TableCell className="font-medium">{r.employee_name}</TableCell>}
            <TableCell>{formatDate(r.review_date)}</TableCell>
            <TableCell>{r.overall_score != null ? r.overall_score.toFixed(2) : '—'}</TableCell>
            <TableCell>
              <Badge className={STATUS_BADGE[r.status] || 'bg-slate-100 text-slate-700'}>{r.status}</Badge>
            </TableCell>
            <TableCell>{r.next_review_date ? formatDate(r.next_review_date) : '—'}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
